"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Videoshowreel() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headline = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const image1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const image2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const image3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const wayfind = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3939" id="videoshowreel" className="relative text-foreground md:min-h-[85vh] overflow-hidden ![padding:50px_0px_50px_0px] bg-background/0 !opacity-[1]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 relative">
        <AspectRatio ratio={16 / 9} className="w-full overflow-hidden rounded-lg shadow-lg">
          <iframe className="w-full h-full" src="https://www.youtube.com/embed/DGnEH4tV65g?si=iDlu0u8X-tnxXbt4" title="Showreel Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        </AspectRatio>
        <div className="mt-8 flex justify-center">
          <Link to="/">
            <Button variant="secondary" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-9 px-4 py-2 has-[>svg]:px-3 !text-center bg-secondary text-black !font-serif !font-semibold disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-white dark:border-input">ABOUT THE COMPOSER</Button>
          </Link>
        </div>
      </div>
    </section>;
}